import React, { Component } from 'react'

export const FecharIcon = () => <ion-icon id="btn_fechar" name="close-outline" />
